module.exports = __webpack_public_path__ + "img/pic1.c36b1d0c.png";